import { isValidCardNumber, isValidCvv, normalizeCardNumber } from '../../shared/card-number';
import { Component, OnInit, OnDestroy, ApplicationRef, ViewChild, TemplateRef } from '@angular/core';
import { FormsApiService } from '@app/core/api/services/forms-api.service';
import { PaymentsApiService } from '@app/core/api/services/payments-api.service';
import { Router, ActivatedRoute, UrlSerializer } from '@angular/router';
import { Location } from '@angular/common';
import { environment } from '@environments/environment';
import { FormField } from "@app/core/api/models/FormField";
import { ContentField } from "@app/core/api/models/ContentField";
import { ContactField } from "@app/core/api/models/ContactField";
import { ContactType } from "@app/core/api/models/ContactType";
import { RadioField } from "@app/core/api/models/RadioField";
import { CheckboxField } from "@app/core/api/models/CheckboxField";
import { DonationField } from "@app/core/api/models/DonationField";
import { TextField } from "@app/core/api/models/TextField";
import { NumberField } from "@app/core/api/models/NumberField";
import { DateField } from "@app/core/api/models/DateField";
import { SharedModule } from '../../shared/shared.module';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { SEOService } from '@app/shared/seo.service';
import { PaypalService } from '@app/shared/paypal.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { YouTubePlayer } from '@angular/youtube-player';
import Editor from 'ckeditor5/build/ckeditor';
import * as Handlebars from "handlebars";
import * as moment from 'moment';
import {tap} from "rxjs/operators";
import * as _ from 'lodash';
import { EnvironmentService } from '@environments/environment.service';
import { LoadingService } from '@app/shared/loading.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import {
  UntypedFormBuilder,
  Validators,
  ValidatorFn,
  ValidationErrors,
  UntypedFormArray,
  FormArray,
  FormControl,
  FormGroup,
  AbstractControl,
  FormsModule,
  ReactiveFormsModule
} from '@angular/forms';
import { LocationService } from '@app/core/services/location.service';
import { Observable, lastValueFrom } from 'rxjs';
import { LocationCode } from '@app/core/models/location.model';
import { NgxCurrencyInputMode } from "ngx-currency";
import { ReCaptchaV3Service } from 'ng-recaptcha';



// Handle on global paypal var
declare var paypal: any;

const iframeCSS: string = `
  br {
    display: none;
  }
  label {
    font-weight: 400;
    margin: 0;
    color: #222;
    font-family: monospace;
    font-size: 13px;
    display: block;
    padding: 1em 0 0.5em;
  }
  label:first-child {
    padding-top: 0.5em;
  }
  input,
  select {
    display: block;
    padding: 0.25em 0.5em;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    border: 1px solid #B9BFC5;
    border-radius: 0.2em;
  }
  input:focus,
  select:focus {
    color: #495057;
    background-color: #fff;
    border-color: #80bdff;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  }
  select {
    display: inline-block;
    width: 80px;
  }
  input {
    width: 90%;
  }
`;

window.moment = moment;

@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  styleUrl: './form.component.scss'
}) export class FormComponent implements OnInit, OnDestroy {

  minDonation: number = 5;
  modalRef?: BsModalRef;
  signatureHolder: string = '';
  signatureFieldIndex?: number;
  customCurrencyMaskConfig: any = {
    align: 'right',
    allowNegative: false,
    allowZero: false,
    decimal: '.',
    precision: 2,
    prefix: '$',
    suffix: '',
    thousands: ',',
    nullable: false,
    min: null,
    max: null,
    inputMode: NgxCurrencyInputMode.Natural
  };


  openModal(template: TemplateRef<void>, fieldIndex: number) {
    this.signatureFieldIndex = fieldIndex;

    const currentSig = this.submissionFields.at(this.signatureFieldIndex).value.value;
    if (currentSig !== null) this.signatureHolder = currentSig;
    this.modalRef = this.modalService.show(template);
  }

  addSignature() {
    if (this.signatureFieldIndex !== undefined) {
      this.submissionFields.at(this.signatureFieldIndex).patchValue({value: this.signatureHolder});
    }

    this.closeModal();
  }

  closeModal() {
    this.signatureFieldIndex = undefined;
    this.signatureHolder = '';
    this.modalRef?.hide();
  }



  title = 'cufi.forms.ui';
  adminPreview: boolean = false;
  formLoading: boolean = true;
  snap: any;
  formId!: number;
  Editor = Editor;
  showCustom = false;
  showValidation: boolean = false;
  submissionComplete: boolean = false;
  donationIndex?: number;
  contactIndex?: number;
  donationHidden?: boolean = false;
  contactHidden?: boolean = false;
  formNotFound: boolean = false;
  validToken: boolean = false;
  tokenQueried: boolean = false;
  customDonationToday?: number;
  customDonationMonthly?: number;
  showPaypalButton: boolean = false;
  queryParams: any = {};
  dayOptions: number[] = [...Array(28).keys()];
  monthOptions: string[] = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
    'January' // allow access for end of year
  ];
  currentDateM: any = moment();
  currentYear: number = this.currentDateM.year();
  currentMonth: number = this.currentDateM.month();
  currentDate: number = this.currentDateM.date();
  cutoffDateM: any = moment().add(5, 'days');
  futureDonationDateM: any = moment().date(1);
  explainDate: boolean = false;

  updateFFD(date?: any) {
    let newDate = moment().date(date ? +date.target.value : 1);

    // Add month if date is passed
    while (newDate < this.currentDateM) {
      newDate.add(1, 'month');
    }

    // If this months date is too soon
    if (newDate < this.cutoffDateM) {
      newDate.add(1, 'month');
      this.explainDate = true;
    } else {
      this.explainDate = false;
    }

    this.futureDonationDateM = newDate;
  }

  displaySingleDonation: boolean = false;
  displayMonthlyDonation: boolean = false;
  submissionData: any = {};
  apiUrl: string = '';
  referrer: string = '';
  requestUrl: string = '';
  modifiedRequestUrl: string = '';
  countries$: Observable<LocationCode[]>;
  availableStatesProvinces$: Observable<LocationCode[]> | null = null;
  addressBlockStates: { [key: string]: Observable<LocationCode[]> } = {};

  // reCAPTCHA v3/v2 hybrid properties
  recaptchaV2SiteKey: string = '';
  showFallbackCaptcha: boolean = false;
  // True from the tap until the API replies; a second tap in that window must not submit again.
  submitting: boolean = false;
  captchaError: boolean = false;
  standardEditorConfig = {toolbar: [
    'bold',
    'italic',
    '|',
    'numberedList',
    'bulletedList',
    '|',
    'link'
  ]};

  iframeCCSrc: string = 'https://fts-uat.cardconnect.com/itoke/ajax-tokenizer.html' +
    '?css=' + encodeURIComponent(iframeCSS) +
    '&useexpiry=true&usecvv=true';
  iframeACHSrc: string = 'https://fts-uat.cardconnect.com/itoke/ajax-tokenizer.html' +
    '?css=' + encodeURIComponent(iframeCSS) +
    '&fullmobilekeyboard=true';


  donationValidation: ValidatorFn = (donationGroup: AbstractControl): ValidationErrors | null => {
    const val = donationGroup.value.value;

    // No donation, no validation
    if (val.showSingle === false && val.showMonthly === false) {
      return null;
    }

    // Single Donation Validation
    if (val.showSingle) {
      // Missing Amount
      if (
        val.single.amount === null ||
        (val.single.amount === -1 && !this.customDonationToday)
      ) {
        return { missingDonationInfo: true };
      }

      // Not Enough
      if (
        val.single.amount === -1 &&
        typeof this.customDonationToday === 'number' &&
        this.customDonationToday < this.minDonation
      ) {
        return { insufficientDonation: true };
      }
    }

    // Single Donation Validation
    if (val.showMonthly) {
      // Missing Amount
      if (
        val.monthly.amount === null ||
        (val.monthly.amount === -1 && !this.customDonationMonthly)
      ) {
        return { missingDonationInfo: true };
      }

      // Not Enough
      if (
        val.monthly.amount === -1 &&
        typeof this.customDonationMonthly === 'number' &&
        this.customDonationMonthly < this.minDonation
      ) {
        return { insufficientDonation: true };
      }
    }

    // Validate CC
    if (val.paymentType === 'cc') {
      if (
        !val.account ||
        !val.name ||
        !val.verificationCode ||
        !val.postalCode
      ) {
        return { missingCCInfo: true };
      }

      if (!isValidCardNumber(normalizeCardNumber(val.account))) {
        return { invalidCardNumber: true };
      }

      if (!isValidCvv(val.verificationCode, normalizeCardNumber(val.account))) {
        return { invalidCvv: true };
      }

      if (
        +val.expiryYYYY === this.currentYear &&
        +val.expiryMM <= new Date().getMonth()
      ) {
        return {cardExpired: true};
      }
    }

    // Validate Bank Xfer
    if (val.paymentType === 'ach') {
      if (
        !val.account ||
        !val.name ||
        !val.routing ||
        !val.accountType
      ) {
        return { missingCCInfo: true };
      }
    }

    // All good
    return null;
  }


  updateContactRequirements(submissionGroup: FormGroup, adminObj: any) {
    const isOrg = submissionGroup.value.isOrg;

    // Start by removing all requirements
    for (let control in submissionGroup.controls) {
      submissionGroup.get(control)?.removeValidators(Validators.required);
      submissionGroup.get(control)?.updateValueAndValidity();
    }

    // Bail if copying another address
    if (submissionGroup.value.copyPrimary || submissionGroup.value.copyBilling) return;

    // Otherwise loop through fields
    for (let key in adminObj.fields) {
      if (adminObj.fields[key].required && adminObj.fields[key].display) {
        switch (key) {
          case 'name':
            if (isOrg) {
              submissionGroup.get('orgName')?.addValidators(Validators.required);
              submissionGroup.get('orgName')?.updateValueAndValidity();
            } else {
              submissionGroup.get('firstName')?.addValidators(Validators.required);
              submissionGroup.get('firstName')?.updateValueAndValidity();
              submissionGroup.get('lastName')?.addValidators(Validators.required);
              submissionGroup.get('lastName')?.updateValueAndValidity();
            }
            break;
          case 'birthday':
          case 'gender':
            if (!isOrg) {
              submissionGroup.get(key)?.addValidators(Validators.required);
              submissionGroup.get(key)?.updateValueAndValidity();
            }
            break;
          case 'phone':
            submissionGroup.get(key)?.get('number')?.addValidators(Validators.required);
            submissionGroup.get(key)?.get('number')?.updateValueAndValidity();
            break;
          default:
            submissionGroup.get(key)?.addValidators(Validators.required);
            submissionGroup.get(key)?.updateValueAndValidity();
            break;
        }
      }
    }
  }


  // Admin Form
  adminForm = this.formBuilder.group({
    id: [undefined],
    startDate: [null],
    endDate: [null],
    name: ['', Validators.required],
    active: [false, Validators.required],
    errorMessage: [''],
    successMessage: [''],
    confirmationEmailMessage: [''],
    formFields: this.formBuilder.array([]),
    modifiedBy: [''],
    modifiedOn: [''],
    metaTitle: [''],
    metaDescription: [''],
    metaImage: [''],
    revisionId: [''],
    slug: [''],
    submitText: ['']
  });


  // Submission Form
  submissionForm = this.formBuilder.group({
    fields: this.formBuilder.array([])
  });


  // Getters
  get adminFields(): FormArray {
    return this.adminForm.get('formFields') as FormArray;
  }
  get submissionFields(): FormArray {
    return this.submissionForm.get('fields') as FormArray;
  }
  fieldOptions(field: any): FormArray {
    return field.get('options') as FormArray;
  }
  monthlyDonations(field: any): FormArray {
    return field.get('monthlyOptions') as FormArray;
  }
  oneTimeDonations(field: any): FormArray {
    return field.get('oneTimeOptions') as FormArray;
  }
  contactTypeAdminGroup(data: ContactType) {
    return this.formBuilder.group({
      enabled: data.enabled,
      fields: this.formBuilder.group({
        name: this.formBuilder.group(data.fields?.name || {}),
        email: this.formBuilder.group(data.fields?.email || {}),
        streetAddress: this.formBuilder.group(data.fields?.streetAddress || {}),
        city: this.formBuilder.group(data.fields?.city || {}),
        state: this.formBuilder.group(data.fields?.state || {}),
        postalCode: this.formBuilder.group(data.fields?.postalCode || {}),
        country: this.formBuilder.group(data.fields?.country || {}),
        phone: this.formBuilder.group(data.fields?.phone || {}),
        gender: this.formBuilder.group(data.fields?.gender || {}),
        birthday: this.formBuilder.group(data.fields?.birthday || {}),
      })
    });
  }
  contactTypeSubmissionGroup(type: any, key: string, cloneParent: boolean = false): FormGroup | null {
    if (!type.enabled) {
      return null;
    }

    let displayedFields: any = {
      // Extra fields added for submission
      copyPrimary: [cloneParent && key === 'billing'],
      copyBilling: [cloneParent && key === 'shipping'],
      streetAddress2: [null],
      isOrg: [false],
      firstName: [null],
      lastName: [null],
      orgName: [null]
    };

    const hasCountryField = type.fields.country && type.fields.country.display;
    const hasStateField = type.fields.state && type.fields.state.display;

    // parse fields
    for (let field in type.fields) {
      if (type.fields[field].display) {
        if (field === 'email') {
          displayedFields[field] = [null, Validators.email];
        } else if (field === 'phone') {
          displayedFields[field] = this.formBuilder.group({
            number: [''],
            messagingAllowed: [true]
          });
        } else if (field === 'country') {
          displayedFields[field] = ['US'];
        } else if (field === 'state') {
          displayedFields[field] = [''];
        } else {
          displayedFields[field] = [null];
        }
      }
    }

    // If state field exists but country field doesn't, add country field with US default
    if (hasStateField && !hasCountryField) {
      displayedFields['country'] = ['US'];
    }

    let contactTypeGroup = this.formBuilder.group(displayedFields);
    this.updateContactRequirements(contactTypeGroup, type);

    // Initialize states based on country presence
    if (hasStateField) {
      const countryCode = 'US'; // Always default to US
      this.initializeStatesForAddressBlock(key, countryCode);
    }

    return contactTypeGroup;
  }

  private initializeStatesForAddressBlock(blockKey: string, countryCode: string): void {
    // Create a unique observable for this address block
    const blockStatesKey = `${blockKey}_states`;
    if (!this.addressBlockStates) {
      this.addressBlockStates = {};
    }
    this.addressBlockStates[blockStatesKey] = this.locationService.getStatesProvinces(countryCode);
  }

  updateAvailableStatesProvinces(submissionGroup: FormGroup, blockKey: string): void {
    const countryCode = submissionGroup.value.country || 'US';

    const blockStatesKey = `${blockKey}_states`;
    if (!this.addressBlockStates) {
      this.addressBlockStates = {};
    }
    this.addressBlockStates[blockStatesKey] = this.locationService.getStatesProvinces(countryCode);

    submissionGroup.get('state')?.setValue('');
  }

  getStatesForAddressBlock(blockKey: string): Observable<LocationCode[]> | null {
    if (!this.addressBlockStates) return null;
    const blockStatesKey = `${blockKey}_states`;
    return this.addressBlockStates[blockStatesKey] || null;
  }



  constructor(
    private router: Router,
    private formsApiService: FormsApiService,
    private paymentsApiService: PaymentsApiService,
    private activeRoute: ActivatedRoute,
    private formBuilder: UntypedFormBuilder,
    private seoService: SEOService,
    private serializer: UrlSerializer,
    private location: Location,
    public sanitizer: DomSanitizer,
    private paypalService: PaypalService,
    private applicationRef: ApplicationRef,
    private environmentService: EnvironmentService,
    private loadingService: LoadingService,
    private locationService: LocationService,
    private modalService: BsModalService,
    private recaptchaV3Service: ReCaptchaV3Service
  ) {
    this.environmentService.environment.pipe(
      tap((env) => {
        this.apiUrl = env.apiUrl;
        this.recaptchaV2SiteKey = env.recaptchaV2SiteKey ?? '';
      })
    ).subscribe();

    this.referrer = document.referrer;
    this.requestUrl = document.URL;
    this.countries$ = this.locationService.getCountries();
  }

  async ngOnInit() {
    this.snap = this.activeRoute.snapshot;
    this.queryParams = this.snap.queryParams;
    this.adminPreview = this.queryParams.admin_preview === 'true';
    this.updateFFD();

    const idUrl = !!this.snap.params['id'];
    const vanityUrl = !!this.snap.params['vanity'];
    const defaultUrl = !!this.snap.params['default'];

    this.loadingService.start();
    let form;

    // Query form (suppress error)
    try {
      if (idUrl) {
        form = await this.queryById( +this.snap.params['id'] );
      } else if (vanityUrl) {
        form = await this.queryByVanity( this.snap.params['vanity'] );
      } else if (defaultUrl) {
        form = await this.queryByDefault( this.snap.params['default'] );
      } else { // blankUrl
        form = await this.queryByDefault( 'donation' );
      }
    } catch(e) {}

    // Reroute if failed/inactive
    if (
      !form ||
      form?.active === false ||
      this.beforeDate(form?.startDate) ||
      this.afterDate(form?.endDate)
    ) {
      this.rerouteToDefault(form?.redirect);
      return;
    }

    // Update URL
    if (!vanityUrl) {
      if (!!form.slug) { // Use Vanity if possible
        this.location.replaceState(form.slug, window.location.search);
      } else if (!!form.isDefaultForm) { // Otherwise try Default
        this.location.replaceState('/default/'+form.isDefaultForm, window.location.search);
      }
    }

    // Save modified URL
    this.modifiedRequestUrl = document.URL;

    // Custom donation minimum for specific form (#396 in prod)
    if (form.id === 396) {
      this.minDonation = 1000;
    }

    // Format Data
    this.formatData(form);
    this.setupPaypal();

    // SEO Updates
    this.seoService.update(
      this.adminForm.value.metaTitle,
      this.adminForm.value.metaDescription,
      this.adminForm.value.metaImage
    );

    this.loadingService.stop();
  }


  queryById(id: number) {
    return lastValueFrom(this.formsApiService.GetForm({
      path: { id: id }
    }));
  }
  queryByVanity(vanity: string) {
    return lastValueFrom(this.formsApiService.GetFormByVanity({
      path: { slug: vanity }
    }));
  }
  queryByDefault(type: string) {
    return lastValueFrom(this.formsApiService.GetDefaultForm({
      path: {type: type}
    }));
  }


  async rerouteToDefault(defaultForm: string = 'donation') {
    await this.router.navigate(
      ['/default/'+defaultForm],
      {queryParams: this.queryParams}
    );

    window.location.reload();
  }


  formatData(formQueried: any) {
    this.formId = formQueried.id;
    this.adminForm.patchValue(formQueried);

    // Process Form Fields
    if (!formQueried?.formFields?.length) {
      this.loadingService.stop();
      return;
    }

    // Loop through form fields
    let processedFields = this.formBuilder.array([]);
    for (let i = 0; i < formQueried.formFields.length; i++) {
      let field = formQueried.formFields[i];

      switch (field.type) {
        case 'plain-text':
          processedFields.push(this.formBuilder.group(field));
          const textField = field as TextField;

          // Validators
          let textValidators = [];
          if (textField.required) {
            textValidators.push(Validators.required);
          }
          if (!!textField.minimumCharacters) {
            textValidators.push(Validators.minLength(textField.minimumCharacters));
          }
          if (!!textField.maximumCharacters) {
            textValidators.push(Validators.maxLength(textField.maximumCharacters));
          }

          this.submissionFields.push(
            this.formBuilder.group({
              id: textField.id,
              value: [null, textValidators]
            })
          );
          break;

        case 'richText':
          processedFields.push(this.formBuilder.group(field));

          this.submissionFields.push(
            this.formBuilder.group({
              id: field.id,
              value: [null, field.required ? Validators.required : null]
            })
          );
          break;

        case 'agreement':
          processedFields.push(this.formBuilder.group(field));

          this.submissionFields.push(
            this.formBuilder.group({
              id: field.id,
              value: [null, field.required ? Validators.requiredTrue : null]
            })
          );
          break;

        case 'signature':
          processedFields.push(this.formBuilder.group(field));

          this.submissionFields.push(
            this.formBuilder.group({
              id: field.id,
              value: [null, field.required ? Validators.required : null]
            })
          );
          break;

        case 'number':
          processedFields.push(this.formBuilder.group(field));
          const numberField = field as NumberField;

          // Validators
          let numberValidators = [];
          if (numberField.required) {
            numberValidators.push(Validators.required);
          }
          if (!!numberField.minimum) {
            numberValidators.push(Validators.min(numberField.minimum));
          }
          if (!!numberField.maximum) {
            numberValidators.push(Validators.max(numberField.maximum));
          }

          this.submissionFields.push(
            this.formBuilder.group({
              id: field.id,
              value: [null, numberValidators]
            })
          );
          break;

        case 'email':
          processedFields.push(this.formBuilder.group(field));

          this.submissionFields.push(
            this.formBuilder.group({
              id: field.id,
              value: field.required ?
                [null, [Validators.required, Validators.email]] :
                [null, Validators.email]
            })
          );
          break;

        case 'phone':
          processedFields.push(this.formBuilder.group(field));

          this.submissionFields.push(
            this.formBuilder.group({
              id: field.id,
              value: this.formBuilder.group({
                number: field.required ?
                  ['', [Validators.required]] :
                  [''],
                messagingAllowed: [true]
              })
            })
          );
          break;

        case 'url':
          processedFields.push(this.formBuilder.group(field));

          const urlPattern = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/;

          this.submissionFields.push(
            this.formBuilder.group({
              id: field.id,
              value: field.required ?
                [null, [Validators.required, Validators.pattern(urlPattern)]] :
                [null, Validators.pattern(urlPattern)]
            })
          );
          break;

        case 'date':
          let dateField = field as DateField;
          processedFields.push(this.formBuilder.group(dateField));

          if (dateField.range) {
            this.submissionFields.push(
              this.formBuilder.group({
                id: field.id,
                value: this.formBuilder.group({
                  start: [null, field.required ? Validators.required : null],
                  end: [null, field.required ? Validators.required : null]
                })
              })
            );
          } else {
            this.submissionFields.push(
              this.formBuilder.group({
                id: field.id,
                value: [null, field.required ? Validators.required : null]
              })
            );
          }


          break;

        case 'radio':
          let radioField = field as RadioField;
          let radioOptions = this.formBuilder.array([]);
          let defaultRadioOption = null;

          // Loop through radio options
          if (radioField.options) {
            for (let j = 0; j < radioField.options.length; j++) {
              radioOptions.push(this.formBuilder.group(radioField.options[j]));
              if (radioField.options[j].default) {
                defaultRadioOption = radioField.options[j].value;
              }
            }
          }

          let radioGroup = this.formBuilder.group({
            ...radioField,
            options: radioOptions
          });

          processedFields.push(radioGroup);
          this.submissionFields.push(
            this.formBuilder.group({
              id: field.id,
              value: [defaultRadioOption, field.required ? Validators.required : null]
            })
          );
          break;

        case 'checkbox':
          let checkField = field as CheckboxField;
          let checkOptions = this.formBuilder.array([]);
          let defaultChecks = this.formBuilder.array([]);

          // Loop through options
          if (checkField.options) {
            for (let j = 0; j < checkField.options.length; j++) {
              checkOptions.push(this.formBuilder.group(checkField.options[j]));

              // Save ID if checked by default
              if (checkField.options[j].default) {
                defaultChecks.push(new FormControl(checkField.options[j].id));
              }
            }
          }

          let checkGroup = this.formBuilder.group({
            ...checkField,
            options: checkOptions
          });

          processedFields.push(checkGroup);
          this.submissionFields.push(
            this.formBuilder.group({
              id: field.id,
              value: defaultChecks
            })
          );
          break;

        case 'contact':
          this.contactIndex = i;
          let contactField = field as ContactField;
          this.contactHidden = contactField.hidden;
          let contactGroup = this.formBuilder.group({
            ...contactField,
            primary: this.contactTypeAdminGroup(contactField.primary),
            shipping: this.contactTypeAdminGroup(contactField.shipping),
            billing: this.contactTypeAdminGroup(contactField.billing)
          });

          processedFields.push(contactGroup);
          let submissionObj = this.formBuilder.group({
            primary: this.contactTypeSubmissionGroup(
              contactField.primary,
              'primary'
            ),
            billing: this.contactTypeSubmissionGroup(
              contactField.billing,
              'billing',
              contactField.commonInputsIndicated && contactField.primary.enabled
            ),
            shipping: this.contactTypeSubmissionGroup(
              contactField.shipping,
              'shipping',
              contactField.commonInputsIndicated && contactField.billing.enabled
            ),
          });

          let contactSubmission = this.formBuilder.group({
            id: field.id,
            value: submissionObj,
          });

          this.submissionFields.push(contactSubmission);
          break;

        case 'donation':
          this.donationIndex = i;
          let donationField = field as DonationField;
          this.donationHidden = donationField.hidden;
          let oneTimeOptions = this.formBuilder.array([]);
          let monthlyOptions = this.formBuilder.array([]);

          // Loop through donation options
          if (donationField.oneTimeOptions) {
            for (let j = 0; j < donationField.oneTimeOptions.length; j++) {
              oneTimeOptions.push(this.formBuilder.group(donationField.oneTimeOptions[j]));
            }
          }
          if (donationField.monthlyOptions) {
            for (let j = 0; j < donationField.monthlyOptions.length; j++) {
              monthlyOptions.push(this.formBuilder.group(donationField.monthlyOptions[j]));
            }
          }

          let donationGroup = this.formBuilder.group({
            ...donationField,
            oneTimeOptions: oneTimeOptions,
            monthlyOptions: monthlyOptions
          });

          processedFields.push(donationGroup);

          let donationSubmission = this.formBuilder.group({
            id: field.id,
            value: this.formBuilder.group({
              showSingle: [false], // UI only
              showMonthly: [false], // UI only
              paymentType: ['cc'],
              account:  [null],
              verificationCode: [null],
              expiryMM: [null],
              expiryYYYY: [null],
              name: [null],
              postalCode: [null],
              routing: [null], // ACH only
              accountType: [null], // ACH only
              single: this.formBuilder.group({ // nullify if no donation
                amount: [null],
              }),
              monthly: this.formBuilder.group({ // nullify if no donation
                amount: [null],
                donationDate: [1],
              })
            })
          }, { validators: this.donationValidation });

          this.submissionFields.push(donationSubmission);
          break;

        default:
          processedFields.push(this.formBuilder.group(field));
          this.submissionFields.push(
            this.formBuilder.group({
              id: field.id,
              value: null,
              contentField: true
            })
          );
          break;
      }
    }

    // Set Fields on Form
    this.adminForm.setControl('formFields', processedFields);
  }


  setupPaypal() {
    // Only run if donation present
    if (this.donationIndex === undefined || this.donationHidden) return;

    const donationField = this.submissionFields.at(this.donationIndex);
    const paymentType = donationField.value.value.paymentType;

    // Load paypal sdk
    this.paypalService.addScript().subscribe(
      () => paypal.Buttons({
        style: {label:  'checkout'},
        createVaultSetupToken: async () => {
          const result = await fetch(this.apiUrl + "/v1/Payments/paypal/vaultSetupToken");
          var jsonRes = await result.json()
          const { token } = jsonRes;
          return token;
        },
        onApprove: async ({vaultSetupToken}: any) => {
          const response = await fetch(this.apiUrl + "/v1/Payments/paypal/paymentToken", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({vaultSetupToken})
          });
          const json = await response.json();
          //@ts-ignore
          this.submissionFields.at(this.donationIndex).get('value').patchValue({account: json.id});

          this.initSubmit();
        },
        onError: (err : any) => {}
      }).render('#paypal-container')
    );
  }

  updateButtonType() {
    if (this.donationIndex === undefined || this.donationHidden) {
      this.showPaypalButton = false;
      return;
    }

    const donationField = this.submissionFields.at(this.donationIndex);
    const donationValue = donationField.value.value;
    const paymentType = donationField.value.value.paymentType;

    donationField.get('value')?.reset({
      ...donationValue,
      account: null,
      verificationCode: null,
      expiryMM: null,
      expiryYYYY: null,
      name: null,
      postalCode: null,
      routing: null, // ACH only
      accountType: null // ACH only
    });

    this.showPaypalButton = paymentType === 'paypal' ? true : false;
  }

  selectCustomDonation(index: number, type: string) {
    this.submissionFields.at(index).get('value')?.get(type)?.patchValue({amount: -1});
  }

  toggleDonationType(field: any, type: string) {
    if (!field.value.value.showSingle) {
      delete this.customDonationToday;
      field.get('value').get('single').patchValue({amount: null});
    }

    if (!field.value.value.showMonthly) {
      delete this.customDonationMonthly;
      field.get('value').get('monthly').patchValue({amount: null});
    }
  }

  removeCustomAmount(type: string) {
    if (type === 'single') {
      delete this.customDonationToday;
    } else if (type === 'monthly') {
      delete this.customDonationMonthly;
    }
  }

  focusOnCustom(id: string) {
    const customDonationInput = document.querySelector('#' + id) as HTMLInputElement;
    customDonationInput?.focus();
  }


  // Checkbox logic (array of IDs)
  updateCheck(e: Event, fieldIndex: number) {
    const input = < HTMLInputElement > e.target ?? null;
    let idArray = this.submissionFields.at(fieldIndex).get('value') as FormArray;

    if (input.checked) {
      idArray.push(new FormControl(input.value));
    } else {
      for (let i = 0; i < idArray.controls.length; i++) {
        if (idArray.controls[i].value === input.value) {
          idArray.removeAt(i);
          break;
        }
      }
    }
  }

  formatSubmission(): any[] {
    // Don't edit source controls
    let newFinal: any[] = [];

    // Clone submission in case of error
    this.submissionFields.value.forEach((field: any) => {
      newFinal.push( _.cloneDeep(field) );
    });

    // Process Donation Field
    if (this.donationIndex !== undefined && !this.donationHidden) {
      let donationObject = newFinal[this.donationIndex];

      if (!donationObject.value.showSingle && !donationObject.value.showMonthly) {
        // No donation made
        donationObject.value = null;
      } else {
        // Process Single Donation
        if (!donationObject.value.showSingle) {
          donationObject.value.single = null;
        } else {
          if (donationObject.value.single.amount === -1) {
            donationObject.value.single.amount = this.customDonationToday;
          }
        }

        // Process Monthly Donation
        if (!donationObject.value.showMonthly) {
          donationObject.value.monthly = null;
        } else {
          if (donationObject.value.monthly.amount === -1) {
            donationObject.value.monthly.amount = this.customDonationMonthly;
          }
        }

        //  CC Values
        if (donationObject.value.paymentType === 'cc') {
          donationObject.value.account = normalizeCardNumber(donationObject.value.account);
          donationObject.value.expiry = donationObject.value.expiryYYYY + donationObject.value.expiryMM;
        }

        // Remove UI props
        delete donationObject.value.showSingle;
        delete donationObject.value.showMonthly;
      }
    }

    // Process Contact Field
    if (this.contactIndex !== undefined && !this.contactHidden) {
      let contactObject = newFinal[this.contactIndex];

      if (contactObject.value.billing?.copyPrimary) {
        contactObject.value.billing = contactObject.value.primary;
        delete contactObject.value.billing.copyPrimary;
        delete contactObject.value.billing.copyBilling;
      }

      if (contactObject.value.shipping?.copyBilling) {
        contactObject.value.shipping = contactObject.value.billing;
        delete contactObject.value.shipping.copyPrimary;
        delete contactObject.value.shipping.copyBilling;
      }

      for (let ctype in contactObject.value) {
        if (contactObject.value[ctype]?.isOrg) {
          delete contactObject.value[ctype].firstName;
          delete contactObject.value[ctype].lastName;
          delete contactObject.value[ctype].gender;
          delete contactObject.value[ctype].birthday;
        } else {
          delete contactObject.value[ctype]?.orgName;
        }
      }
    }
    return newFinal;
  }


  // reCAPTCHA fallback (v2) event handlers
  onFallbackResolved(token: string | null) {
    if (token) {
      this.submitOnce(() => this.callSubmit(token, 'v2'));
    }
  }

  onFallbackExpired() {
  }

  onFallbackError() {
    this.captchaError = true;
  }

  async initSubmit() {
    if (this.submitting || this.showFallbackCaptcha || this.submissionComplete) return;
    if (!this.submissionForm.valid) {
      this.showValidation = true;
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      document.querySelector('#start')?.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      return;
    }
    await this.submitOnce(async () => {
      const token = await lastValueFrom(this.recaptchaV3Service.execute('submit_form'));
      await this.callSubmit(token!, 'v3');
    });
  }

  /**
   * One submission at a time. The flag is set before the first await, so a double tap is refused
   * even during the reCAPTCHA wait; it clears afterwards so a declined donor can correct and retry.
   */
  private async submitOnce(submit: () => Promise<void>): Promise<void> {
    if (this.submitting) return;
    this.submitting = true;
    try {
      await submit();
    } finally {
      this.submitting = false;
    }
  }

  async callSubmit(token: string, version: 'v2' | 'v3') {
    this.captchaError = false;
    this.loadingService.start();
    let cometInfo;
    let sub;

    try {
      // @ts-ignore
      cometInfo = await window.cometGetPageInfo();
    } catch(e) {}

    try {
      let sub = await lastValueFrom(
        this.formsApiService.SaveFormResponse({
          path: {
            id: this.formId,
            revisionId: this.adminForm.value.revisionId
          },
          body: {
            responses: this.formatSubmission(),
            metaData: {
              cometToken: cometInfo?.cometToken,
              referrer: this.referrer,
              requestUrl: this.requestUrl,
              modifiedRequestUrl: this.modifiedRequestUrl,
              sourceCode: this.queryParams.cu_source,
            },
            recaptchaToken: token,
            recaptchaVersion: version
          } as any
        })
      );

      if (sub) {
        this.submissionData.message = sub.message;
      }

      this.submissionComplete = true;
      this.loadingService.stop();
      this.applicationRef.tick();
    } catch (error: any) {
      // If Recaptcha Error (TODO: Improve error identification)
      if (error.status === 400 && error.error.error === 'low_score') {
        this.loadingService.stop();

        if (error?.error?.requiresFallback) {
          this.showFallbackCaptcha = true;
        } else {
          this.captchaError = true;
        }

        this.applicationRef.tick();
      } else {
        // Reset Recaptcha
        if (typeof window.grecaptcha !== 'undefined') {
          grecaptcha.reset();
        }

        // Send to generic error handler
        throw error;
      }
    }
  }


  log() {
    // console.log(this.formatSubmission(), {
    //   referer: this.referrer,
    //   requestUrl: this.requestUrl,
    //   modifiedRequestUrl: this.modifiedRequestUrl,
    // });
    console.log(this.submissionForm.value);
  }


  // Utils
  camelCaseLegible(camel: any): string {
    let result = camel.replace(/([A-Z])/g, " $1");
    return result.charAt(0).toUpperCase() + result.slice(1);
  }


  ordinal(i: number): string {
    let j = i % 10, k = i % 100;
    if (j === 1 && k !== 11) { return i + "st" }
    if (j === 2 && k !== 12) { return i + "nd" }
    if (j === 3 && k !== 13) { return i + "rd" }
    return i + "th";
  }


  youtubeId(url: string) {
    var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    var match = url.match(regExp);
    return (match && match[7].length==11) ? match[7] : false;
  }


  afterDate(date: Date | string | undefined): boolean {
    return !!date ? new Date() > new Date(date) : false;
  }


  beforeDate(date: Date | string | undefined): boolean {
    return !!date ? new Date() < new Date(date) : false;
  }


  hydrateCopy(copy: string): SafeHtml {
    const template = Handlebars.compile(copy);
    return this.sanitizer.bypassSecurityTrustHtml( template(this.submissionData) );
  }


  ngOnDestroy() {
    this.addressBlockStates = {};
  }
}
